export const getComplexReason = (reason: string, otherReason?: string) => {
  return otherReason ? `${reason}: ${otherReason}` : reason;
};
